import React from 'react';
import ManageSignatories from '@pages-clean/shared/manage-signatories/manage-signatories';
import Constants from '@utils/constants';

const CM2ManageSignatories = () => {
    return <ManageSignatories module={Constants.Modules.CM2} />;
};
export default CM2ManageSignatories;
